<template>
	<div id="atlasdetailsbox">
		<div class="atlasdetailsmain">
			<div class="graphloop">
				<el-carousel >
					<el-carousel-item v-for="(item,index) in banner" key="in" >
						<img class="graphloopbg" :src="apiUrl+item.vc_coverphoto"/>
					</el-carousel-item>
					<!--<el-carousel-item>
						<img class="graphloopbg" src="../assets/images/graphbanner2.png" />
					</el-carousel-item>-->
				</el-carousel>
			</div>
			<div class="complete">
					<div class="graphcontent">
						<h2>{{title}}</h2>
							<ul>
								<li>
									<span class="el-icon-thirdicon-yonghu-tianchong">
										
									</span>	
									<a>{{source}}</a>
								</li>
								<li>
									<span class="el-icon-view">
										
									</span>
									<a>{{view}}</a>
								</li>
								<li>
									<span class="el-icon-time">
										
									</span>
									<a>{{createtime}}</a>
								</li>
								<!-- <a>
									<span v-if='!collection_flag' style="font-family: '微软雅黑';color: #73777A;"><span style="cursor: pointer;" @click="collectCase" class="el-icon-star-off"></span>收藏</span>
									<span v-if='collection_flag' style="font-family: '微软雅黑';color: #73777A;"><span style="cursor: pointer;color: #076bf2;" @click="collectCase" class="el-icon-star-on"></span>收藏</span>
								</a> -->
							</ul>
						<!-- 显示内容 -->
						<!--<iframe v-if="contentShow && contentType == '1'" frameborder="no" v-bind:src="'http://39.104.14.210/dataGalaxy'+content" style="width: 100%;height: 100%;background-color: #fff;"></iframe>
						<iframe v-if="contentShow && contentType == '2'" frameborder="no" v-bind:src="content" style="width: 100%;height: 100%;background-color: #fff;"></iframe>-->
						
							
						<!--pdf展示-->
						<div v-show="numPages" v-for="item in pagea" :id="'pdf_box'+item">
							<pdf
					            v-for="i in 1"
					            :key="i"
					            :src="src"
					            :page="item"
					            style="display: inline-block; width:100%"
					        ></pdf>
					        <div :id="'pagecount'+item">
					        	第{{item}}页
					        </div>
						</div>
						
						<!--富文本展示-->
						<div id="html_box" style="text-align: left;
							" v-html="html">
							
						</div>
						<!--<div class=" " style=" width: 944px; float: left; margin-top: 65px; margin-bottom: 60px;list-style-type:none">
							<button style="color:#2978EF;background-color: #F3F3F3;border: 0;cursor: pointer;"><span class="el-icon-thirdicon-gengduo-copy"></span>查看更多</button>
						</div>-->
					</div>

					<!--右侧详情-->
					<div class="sharebox">

						<div class="sharetitle">
							立即分享
						</div>
						<div class="sharelinkbox">
							<div class="de_relationdown_menu">
								<div class="de_relation2down">
									<a>
										分享链接
									</a>
								</div>
								<!--<input type="text" :value="shareUrl">-->
								<textarea :value="shareUrl" spellcheck ="false"></textarea>
							</div>
							<button class="de_copy" id="copybtn" @click="copyurl">复制链接</button>
							
						</div>
					</div>
						<!-- <div style="cursor: pointer;" class="willask" @click="issueCase"> -->
							<!--<button class="askbtn" @click="issueCase">-->
								<!-- 我要提问 -->
							<!--</button>-->
						<!-- </div> -->
					
			</div>

		</div>
		<submitquestionpop ref='submitquestionpop'></submitquestionpop>
	</div>
</template>

<script>
	import Bus from '@/bus.js'
	import pdf from 'vue-pdf'
	import submitquestionpop from '@/messageBox/submitquestionpop.vue'
	export default {
		data() {
			return {
				apiUrl:this.apiUrl,
				shareUrl:'',			//分享链接
				pagea:1,				//默认显示页数
				src: '',				//PDF文件路径
           		numPages: undefined,	//PDF文件总页数
           		html:``	,				//富文本
				graphbanner: ["../assets/images/graphbanner1.png", "../assets/images/graphbanner2.png"],
				uuid: '', //图谱uuid
				title: '', //图谱标题
				view: '', //阅读量
				source: '', //发布人
				content: '', //图谱内容
				createtime: '', //发布时间
				collection_flag: 0, //是否收藏
				contentType:'',		//内容类型
				contentShow: 0,
				collection_flag: 0,
				banner:'',		//轮播图
			}
		},
		components: {
			submitquestionpop,
			pdf
		},
		watch:{
			html:function(){
				var that = this;
				that.$nextTick(that.common.iframeScreenButton)
			}
		},
		beforeRouteLeave(to, from, next) {
			if (to.path == "/graph") {
        	to.meta.keepAlive = true;
     		 } else {
       		 to.meta.keepAlive = false;
      		}
      		next();
		},
		mounted() {

			let _this=this;
			this.uuid = this.$route.query.uuid;
			this.shareUrl = window.location.href;

			//获取数据
			this.$http.get(

				_this.apiUrl+'index.php? m=Api&c=Content&a=atlasDetail', {
					params: {
						"uuid": this.uuid,
						'userCode': sessionStorage.getItem('usercode')
					}
				}
			).then(response => {

				//进行数据验证
				if(response.body.status != 1) {

					//显示错误页面
//					alert('请求错误');
					return;
				}

				if(typeof response.body.data == "undefined" || response.body.data == null || response.body.data == "") {

					//显示空数据页面
//					alert('没有数据');
					return;
				}
				
				//轮播图
				this.banner = response.body.data.advertList;

				this.title = response.body.data.vc_title;
				this.view = response.body.data.vc_page_view;
				this.source = response.body.data.vc_source;
				this.content = response.body.data.vc_content;
				this.createtime = response.body.data.dt_createtime;
				this.collection_flag = response.body.data.is_collection;
				this.contentType = response.body.data.n_contenttype;
				this.contentShow = 1;
								//根据类型判断
				if(this.contentType==1){
				// this.html=this.content;
				//hc 2020年7月9日
					let str = this.content
					// console.log(response.body)
					let url ='src="http://47.93.51.30'
					let new_str = str.replace(/src="/g,url)
			
					this.html=new_str;
					
				}else{
					let loadingTask = pdf.createLoadingTask('http://39.104.14.210/dataGalaxy'+this.content);
				this.src=loadingTask;
				this.src.then(pdf => {
            	this.numPages = pdf.numPages;
        });
				}
			}, response => {
				
			});
		},
		methods: {
			imageLoaded() {
				var that = this;
				that.count++;
				if(that.count==1){
					that.$nextTick(()=>{
						that.bannerHeight = that.$refs.image.height
						
					})
				}
			},
			mycollection(event) {
				if(!this.collection_flag) {
					this.collection_flag = 1;
					event.target.className = 'el-icon-star-on'
					event.target.style.color = '#076bf2'
				} else {
					this.collection_flag = 0;
					event.target.className = 'el-icon-star-off'
					event.target.style.color = ''
				}

			},

			//收藏
			collectCase(event) {
				let _this=this;
				//判断用户是否登录
				if(this.isLogin()) {

					//判断是收藏还是取消收藏
					if(!this.collection_flag) {
						var url = _this.apiUrl+"index.php?m=Api&c=user&a=collectionAdd";
					} else {
						var url = _this.apiUrl+"index.php?m=Api&c=user&a=saveCollection"
					}

					//发送请求,收藏或取消收藏
					this.$http.post(url, {
						userCode: sessionStorage.getItem('usercode'),
						type: 2,
						contentCode: this.uuid
					}, {
						emulateJSON: true
					}).then(
						(response) => {

							//判断是否收藏|取消收藏成功
							if(response.body.status == 1) {
								sessionStorage.setItem('isRefresh',true);
								if(!this.collection_flag) {
									this.collection_flag = 1;
									event.target.className = 'el-icon-star-on'
									event.target.style.color = '#076bf2'
								} else {
									this.collection_flag = 0;
									event.target.className = 'el-icon-star-off'
									event.target.style.color = ''
								}

							} else {
//								alert(response.body.massage);
							}

						},
						(error) => {
//							console.log("error");
						}
					);
				}
			},

			//提问
			issueCase() {
				//判断用户是否登录
				if(this.isLogin()) {

					//弹出提问框
					this.$refs.submitquestionpop.opensubmitquestionpop('2', this.title);
				}
			},

			//判断是否登录
			isLogin() {

				//判断当前是否为登录状态
				if(typeof sessionStorage.getItem('usercode') == "undefined" || sessionStorage.getItem('usercode') == null || sessionStorage.getItem('usercode') == "") {

					//弹出登录页面
					this.$message({
								message: '请先登录',
								type: 'warning',
								customClass: 'message-warning',
							});

					//显示登录页面
//					this.$refs.commonhead.flag = true;

					return false;

				} else {

					return true;
				}

			},

			//复制分享链接
			copyurl() {
				// var Url = 'http://39.104.14.210/dataGalaxy' + this.content;
				var oInput = document.createElement('textarea');
				oInput.value = this.shareUrl;
				document.body.appendChild(oInput);
				oInput.select(); // 选择对象
				document.execCommand("Copy"); // 执行浏览器复制命令
				oInput.className = 'oInput';
				oInput.style.display = 'none';
				this.$message({
								message: '复制成功',
								type: 'warning',
								customClass: 'message-warning',
							});
				
			},
			//查看更多
			showmorepage() {
				if(typeof sessionStorage.getItem('usercode') == "undefined" || sessionStorage.getItem('usercode') == null || sessionStorage.getItem('usercode') == ""){
					
					//弹出登录页面
					//显示登录页面
//					this.$refs.commonhead.flag = true;
					Bus.$emit('showmore',{'flag':true})
					return false;
				
				}else{
					if(this.contentType=='1'){
						this.height.height='auto'
					}else{
						let a=this.pagea
					if(this.pagea<this.numPages){
						this.pagea=this.numPages
					}else{
//						alert('已经到最后了，没有更多了')
					}
					}
					
				}
			},
		}
	}
</script>

<style lang="scss">
.icon{
	width: 0.4rem;
    height: 0.4rem;
}
	.graphloop img{
		height:360px ;
		display: block;
	}
	#html_box img{
		width: 100%;
	}
	#html_box iframe{
		width: 100%;
	}
	#atlasdetailsbox{
		width: 100%;
		background: white;
		.atlasdetailsmain{
			
			.graphloop{
				/*height: 360px;*/
				width: 100%;
			}
			
			.complete{
				overflow: hidden;
				width: 1200px;
				margin: 0 auto;
				
				.graphcontent{
					min-height: 727px;
					width: 944px;
					float: left;
					h2{
						margin-top: 50px;
						text-align: left;
					}
					ul{
						font-size: 14px;
						height: 70px;
						line-height: 70px;
						text-align: left;
						li{
							float: left;
							margin-right: 10px;
							list-style: none;
							span{
								margin: 0 5px;
							}
						}
						a{
							float: right;
						}
					}
					#html_box{
						p{
							iframe{
								height: 531px;
								width: 944px;
								
							}
						}
						
					}
				}
				.sharebox{
					float: right;
					width: 210px;
					border: 1px solid #E6E6E6;
					margin-top: 30px;
					border-radius: 5px 5px 0px 0px;
					text-align: left;
					
					.sharetitle{
						font-weight: 600;
						width: 100%;
						height: 36px;
						line-height: 36px;
						float: left;
						font-size: 14px;
						width: 210px;
						margin: 0 auto;
						/*border: 1px solid #E6E6E6;*/
						text-align: left;
						text-indent: 10px;
						background-color: #E6E6E6;
						/*border-radius: 5px 5px 0px 0px;*/
						font-weight: 600;
					}
					.sharelinkbox{
						width: 100%;
						float: left;
						.de_relationdown_menu{
							width: 100%;
							float: left;
							margin-top: 10px;
							text-align: center;
							.de_relation2down{
								width: 100%;
								height: 25px;
								float: left;
								text-align: left;
								margin-left: 10px;
								a{
									line-height: 20px;
									height: 20px;
									font-size: 14px;
								}
							}
							textarea{
								box-sizing: border-box;
								width: 85%;
								height: 150px;
								/*min-height: 120px;*/
								color: #2c3e50;
								resize: none;
								font-size: 16px;
								padding: 5px;
								
							}
						}
						
						.de_copy{
							cursor: pointer;
							width: 180px;
							height: 32px;
							color: white;
							background: #076CF2;
							border: 0;
							outline: none;
							margin:15px 15px 20px 15px;
						}
					}
					
				}
				.willask{
						float: right;
						width: 208px;
						height:38px ;
						border: 1px solid #076BF2;
						margin-top: 50px;
						color: #076BF2;
						line-height: 38px;
						text-align: center;
					}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/views/atlasdetails.vue